import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { BaseRendererComponent, FormatService, UnitOfMeasures } from 'tms-lib';

@Component({
  selector: 'app-product-quantity-renderer',
  templateUrl: './product-quantity-renderer.component.html',
  styleUrl: './product-quantity-renderer.component.scss',
})
export class ProductQuantityRendererComponent extends BaseRendererComponent implements ICellRendererAngularComp {
  constructor(protected formatService: FormatService) {
    super();
  }

  get productType() {
    return this.rowData[this.params.productTypeField];
  }

  get price() {
    return this.formatService.currency(this.rowData[this.params.priceField], this.rowData[this.params.currencyField]);
  }

  get total() {
    return this.formatService.currency(
      this.rowData[this.params.priceField] * this.params.value,
      this.rowData[this.params.currencyField],
    );
  }

  get unitOfMeasure() {
    return this.rowData[this.params.unitOfMeasureField];
  }

  get canMinus() {
    return this.unitOfMeasure === UnitOfMeasures.each && this.canDelete;
  }

  get canDelete() {
    return this.params.value > 0;
  }

  updateQuantity(event: any) {
    this.params.update({ ...this.rowData, [this.colId]: event.target.value });
  }
}
